import Config from "@skin_config";
import { getAuthData } from "@common/helpers/auth";

// enableOnlinePayment - for controlling octopay with AGP config
// depositMethods.enabled - for having a way with our config to enable on all terminals without AGP config
// enableMultiDepositMode - for not conflicting with other skins where enableOnlinePayment can be true for other payments like hipay/pix ...

export const isMultiDepositModeEnabled = () => {
  const { enableOnlinePayment, betshopid, tid } = getAuthData() || {};

  const octoConfig = Config.depositMethods.find(item => item.type === 'octopay');

  return (+enableOnlinePayment || octoConfig?.enabled)
    && Config.main.enableMultiDepositMode && !octoConfig.disabledBetshopIds?.includes?.(+betshopid) && (!octoConfig.enabledTerminalIds?.length || octoConfig.enabledTerminalIds?.includes(+tid));
}